module.exports = __webpack_public_path__ + "img/cbam-yb-en.5f4721b8.png";